import React from "react";
import FaIcon from '../utils/FaIcon';

const HomeAboutUs = () => (
    <div className='cards-wrapper'>
        <div className='card right-text width-50'>
            <h3 style={{ color: '#e47931' }}>About Us</h3>
            <h1>Where Expertise Meets Excellence</h1>
            <p>We are a top-tier manufacturer specializing in a variety of Electrical & Instrumentation Control Panels for diverse applications, including automation. Our offerings include PLC-based Electrical Control Panels, Fixed & Draw-out Type MCC/PCC Panels, Instrument Panels, SCADA, and Automatic Power Factor Control Panels. With advanced manufacturing facilities in Vijayapur and Bangalore (India), we are equipped with cutting-edge production tools and testing equipment, providing comprehensive in-house capabilities for Fabrication, Manufacturing, Testing, Erection, and Commissioning of Panels.</p>
            <a href="/about" className='primary-btn'>Learn More</a>
        </div>
        <div className='card mini-card-wrapper'>
            <div className='mini-card'>
                <div className='card-icon'>
                    <FaIcon icon="clock" />
                </div>
                <h1>{new Date().getFullYear() - 2010}+</h1>
                <span>Years of Expertise</span>
            </div>
            <div className='mini-card'>
                <div className='card-icon'>
                    <FaIcon icon="check-circle"/>
                </div>
                <h1>252</h1>
                <span>Projects Delivered</span>
            </div>
            <div className='mini-card'>
                <div className='card-icon'>
                    <FaIcon icon="industry"/>
                </div>
                <h1>180 tons</h1>
                <span>Annual Production Capacity</span>
            </div>
            <div className='mini-card'>
                <div className='card-icon'>
                    <FaIcon icon="user-friends"/>
                </div>
                <h1>90+</h1>
                <span>Clients Served</span>
            </div>
        </div>
    </div>
);

export default HomeAboutUs;